import {
    GroupeTravailUtilisateurApiObject,
    UtilisateurApiObject,
} from '@europrocurement/l2d-domain';
import {
    JointureUtilisateurGroupeTravailJsonldUserworkgroupRead as Inscriptions,
    GroupesDeTravailInscriptionsInner as InscriptionDTO,
} from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';
import { format } from 'date-fns';

/**
 * Function that build groupeTravailDTO sub collection
 *
 * Format groupeTravail active members in inscriptionsDTO array
 * @param inscriptionsState State containing inscriptions in groupeTravailActiveInscriptions store
 * @returns InscriptionDTO[]
 */
export const formatInscriptionsDTO = (inscriptionsState: Inscriptions[]) => {
    const insArray: InscriptionDTO[] = inscriptionsState.map((inscr) => {
        const updateInscr: InscriptionDTO = {
            idUserGroupeTravail: inscr.id,
            user: inscr.user?.['@id'] as string,
            groupetravail: inscr.groupetravail?.['@id'] as string,
            fDelete: inscr.fDelete,
            dDebut: inscr.dDebut ?? null,
            dFin: inscr.dFin ?? null,
        };
        return updateInscr;
    });
    return insArray;
};

/**
 * Function that build new member inscription DTO
 *
 * Format an inscriptionDTO from a user and a workgroup
 * @param candidateState State containing an existing user
 * @param workgroup the main workgroup (selected)
 * @returns InscriptionDTO
 */
export const formatNewInscriptionDTO = (
    candidateState: UtilisateurApiObject,
    workgroup: GroupeTravailUtilisateurApiObject,
) => {
    const today: Date = new Date();

    const candidateInscr: InscriptionDTO = {
        idUserGroupeTravail: null,
        user: candidateState['@id'] as string,
        groupetravail: workgroup['@id'] as string,
        fDelete: false,
        dDebut: format(today, 'yyyy-MM-dd'),
        dFin: workgroup.dCloture ? workgroup.dCloture : null,
    };

    return candidateInscr;
};
